<script>
import SystemSettingEdit from './SystemSettingEdit.vue';

export default {
    components: {
        SystemSettingEdit,
    },
    computed: {
        settings() {
            return this.$store.getters.SYSTEM_SETTINGS;
        },
        isLoading() {
            return this.$store.getters.IS_SETTINGS_LOADING;
        },
    },
};
</script>

<template>
    <div class="settings_content">
        <div v-if="isLoading" class="loading_message">
            <p>Загрузка системных настроек...</p>
        </div>
        <div v-else-if="settings.length === 0" class="empty_message">
            <p>Системные настройки не заданы.</p>
            <p class="hint">Обратитесь к администратору для настройки.</p>
        </div>
        <div v-else class="settings_list">
            <SystemSettingEdit
                v-for="setting in settings"
                :key="setting.id"
                :setting="setting"
            />
        </div>
    </div>
</template>

<style scoped>
.settings_content {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
}

.loading_message,
.empty_message {
    text-align: center;
    padding: 40px 20px;
    color: var(--text-secondary);
    font-size: 16px;
}

.empty_message .hint {
    margin-top: 8px;
    font-size: 14px;
    color: var(--text-tertiary);
}

.settings_list {
    display: flex;
    flex-direction: column;
}
</style>
